import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export const inr = (n) => {
  const rounded = Math.round(Number(n || 0));
  return `₹${rounded.toLocaleString("en-IN")}`;
};

export const payableInr = (value) => {
  const amount = Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
  return `₹${amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const paymentModeLabel = (order) => {
  const storedLabel = order?.payment_mode_label || order?.payment_method_label;
  if (storedLabel) return storedLabel;
  const method = String(order?.payment_method || "").trim().toLowerCase();
  if (method === "cod") return "Cash on Delivery";
  if (method === "razorpay") return "Online Payment via Razorpay";
  return method ? method.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase()) : "Not available";
};
